module.exports = __webpack_public_path__ + "img/bianzu_es.ddfcef9b.png";